<template>
  <div class="rightTableDiv">
    <div style="height: 100%;">
      <search-form
        @setSearchCondition="setSearchCondition"
        @clearSearch="clearSearch"
        @openDrawer="openDrawer"
        @derive="derive"
        @handleImport="handleImport"
        @changeScrollY="changeScrollY"
        @saveAdvanced="saveAdvanced"
        :selectedRows="selectedRows"
        class="searchFormDiv"></search-form>
      <a-table
        bordered
        class="assetTable"
        id="assetTable"
        :pagination="pagination"
        :rowKey="record => record.id"
        :columns="columns"
        :dataSource="tableData.data"
        :loading="tableData.loading"
        @change="handleTableChange"
        :rowSelection="{columnWidth: 40, selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :expanded-row-keys.sync="expandedRowKeys"
        :scroll="{ y: scrollY, x: 1830 }"
        :expandIconColumnIndex="2"
        :expandIcon="expandIcon"
        :customRow="changeRow"
        :indentSize="10"
        :rowClassName="rowClassName"
      >
        <!--      设备名称-->
        <template slot="name" slot-scope="text, record">
          <a-tooltip>
            <template slot="title">{{ record.name }}</template>
            <span class="assetNameTable" :style="{marginRight: record.marginRight ? '19px' : '0px',marginLeft: record.marginLeft ? '38px' : '0px'}">{{ record.name }}</span>
          </a-tooltip>
        </template>
        <!--      责任人-->
        <template slot="principalName" slot-scope="text, record">
          <a-tooltip>
            <template slot="title">{{ record.principalName }}</template>
            <span class="assetNameTable">{{ record.principalName }}</span>
          </a-tooltip>
        </template>
        <!--      规格型号-->
        <template slot="specification" slot-scope="text, record">
          <a-tooltip>
            <template slot="title">{{ record.specification }}</template>
            <span class="assetNameTable">{{ record.specification }}</span>
          </a-tooltip>
        </template>
        <template slot="footer">
          <div class="footerDiv">
            <div class="footerDivOne">
              <span>正常状态设备数量：</span>
              <span>{{ tableData.statistics.normalSum ? tableData.statistics.normalSum : 0 }}</span>
            </div>
            <div class="footerDivTwo">
              <span>其他状态设备数量：</span>
              <span>{{ tableData.statistics.abnormalSum ? tableData.statistics.abnormalSum : 0 }}</span>
            </div>
            <div class="footerDivThree">
              <span>正常状态设备金额：</span>
              <span>{{ tableData.statistics.normalaAmount ? tableData.statistics.normalaAmount : 0 }}</span>
            </div>
          </div>
        </template>
      </a-table>
      <div style="height: 40%">
        <data-tabs ref="dataTabs" :model="dataTabsModel"></data-tabs>
      </div>
    </div>
    <drawer-detail ref="drawerDetail" @getTableData="getTableData" @getDataTabs="getDataTabs"></drawer-detail>
    <drawer-export ref="drawerExport"></drawer-export>
    <import-modal ref="importModal" @getTableData="getTableData"></import-modal>
  </div>
</template>
<script>
import SearchForm from '@/views/equipmentLedger/modules/searchForm'
import {
  getEquipmentTableData,
  getEquipmentTableTotal,
  getDeptTreeList,
  getEquipmentBasicInfo
} from '@/api/equipmentLedger'
import DataTabs from './dataTabs.vue'
import { getTableScroll } from '@/views/equipmentLedger/modules/height'
import { mapGetters } from 'vuex'
import DrawerDetail from '@/views/equipmentLedger/modules/drawerDetail'
import drawerExport from '@/views/equipmentLedger/modules/drawerExportModel/drawerExport.vue'
import { getDeviceTypeTree } from '@/api/deviceType'
import moment from 'moment'
import importModal from './importModal.vue'
export default {
  name: 'TableData',
  components: {
    DrawerDetail,
    drawerExport,
    DataTabs,
    SearchForm,
    importModal
  },
  computed: {
    ...mapGetters(['bukrs', 'anlkl']),
    columns () {
      let { sortedInfo } = this
      sortedInfo = sortedInfo || {}
      const columns = [
        {
          title: '序号',
          customRender: (text, record, index) => {
            return record.showIndex ? index + 1 : ''
          },
          align: 'center',
          width: 40
        },
        {
          title: '设备名称',
          customRender: (text, record, index) => {
            if (record.sign === 1) {
              return <a-tooltip placement="topLeft"><template slot="title">{record.name}</template><span class="xuIcon">虚</span><span class="aaa">{record.name}</span></a-tooltip>
            } else {
              return <a-tooltip placement="topLeft"><template slot="title">{record.name}</template><span class="aaa">{record.name}</span></a-tooltip>
            }
          },
          dataIndex: 'name',
          sorter: (a, b) => {},
          sortOrder: sortedInfo.columnKey === 'name' && sortedInfo.order,
          align: 'left',
          ellipsis: true
        },
        {
          title: '设备编号',
          dataIndex: 'equipmentNumber',
          sorter: (a, b) => {},
          sortOrder: sortedInfo.columnKey === 'equipmentNumber' && sortedInfo.order,
          align: 'center',
          width: 90
        },
        {
          title: '内部编号',
          dataIndex: 'interiorCode',
          sorter: (a, b) => {},
          sortOrder: sortedInfo.columnKey === 'interiorCode' && sortedInfo.order,
          align: 'center',
          width: 135
        },
        {
          title: '设备类别',
          dataIndex: 'equipmentTypeName',
          sorter: (a, b) => {},
          sortOrder: sortedInfo.columnKey === 'equipmentTypeName' && sortedInfo.order,
          align: 'center',
          width: 115
        },
        {
          title: '设备状态',
          dataIndex: 'equipmentStatusName',
          sorter: (a, b) => {},
          sortOrder: sortedInfo.columnKey === 'equipmentStatusName' && sortedInfo.order,
          align: 'center',
          width: 90
        },
        {
          title: '处置状态',
          dataIndex: 'disposeType',
          align: 'center',
          width: 90
        },
        {
          title: '归口部门',
          dataIndex: 'relevantdeptname',
          sorter: (a, b) => {},
          sortOrder: sortedInfo.columnKey === 'relevantdeptname' && sortedInfo.order,
          align: 'center',
          width: 115
        },
        {
          title: '使用部门',
          dataIndex: 'usedeptname',
          sorter: (a, b) => {},
          sortOrder: sortedInfo.columnKey === 'usedeptname' && sortedInfo.order,
          align: 'center',
          width: 115
        },
        {
          title: '部门使用人',
          scopedSlots: {
            customRender: 'principalName'
          },
          dataIndex: 'principalName',
          sorter: (a, b) => {},
          sortOrder: sortedInfo.columnKey === 'principalName' && sortedInfo.order,
          align: 'center',
          width: 130
        },
        {
          title: '规格型号',
          dataIndex: 'specification',
          scopedSlots: {
            customRender: 'specification'
          },
          align: 'center',
          width: 130
        },
        {
          title: '购置价值',
          dataIndex: 'kansw',
          sorter: (a, b) => {},
          sortOrder: sortedInfo.columnKey === 'kansw' && sortedInfo.order,
          align: 'center',
          width: 80
        },
        {
          title: '使用年限',
          dataIndex: 'ndjar',
          align: 'center',
          width: 80
        },
        {
          title: '资产信息状态',
          dataIndex: 'assetInfoStatus',
          sorter: (a, b) => {},
          sortOrder: sortedInfo.columnKey === 'assetInfoStatus' && sortedInfo.order,
          align: 'center',
          width: 100
        },
        {
          title: 'WBS号',
          dataIndex: 'wbsNumber',
          sorter: (a, b) => {},
          sortOrder: sortedInfo.columnKey === 'wbsNumber' && sortedInfo.order,
          align: 'center',
          width: 100
        },
        {
          title: '出库日期',
          customRender: (text, record, index) => {
            return record.outboundDeliveryDate ? moment(record.outboundDeliveryDate).format('YYYY-MM-DD') : ''
          },
          dataIndex: 'outboundDeliveryDate',
          align: 'center',
          width: 100
        }
      ]
      return columns
    }
  },
  data () {
    return {
      searchValue: '',
      // 表格数据
      tableData: {
        data: [],
        statistics: {
          normalSum: 0,
          abnormalSum: 0,
          normalaAmount: 0
        },
        loading: false
      },
      tableCurrRowId: null,
      dataTabsModel: {},
      sortedInfo: null,
      scrollY: 0,
      toLeftWidth: 0,
      advanced: false,
      // 搜索条件
      searchModel: {},
      pagination: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '40'],
        showSizeChanger: true,
        showQuickJumper: true
      },
      sort: {},
      // 展开的行
      expandedRowKeys: [],
      // 选中的行
      selectedRows: [],
      selectedRowKeys: [],
      // 左侧树的搜索条件
      treeSearchModel: {},
    }
  },
  created () {
    // 获取表格数据
    this.getDeptData()
    // 获取资产统计
    this.getAssetTotal()
  },
  mounted () {

  },
  watch: {
    bukrs (newValue) {
      console.log(newValue)
      if (newValue !== '') {
        this.treeSearchModel.subcompanyid = newValue
      } else {
        delete this.treeSearchModel.subcompanyid
      }
      if (this.searchModel.subcompanyid) {
        delete this.searchModel.subcompanyid
      }
      this.setSearchCondition(this.searchModel)
    },
    anlkl (newValue) {
      if (newValue !== '' && newValue !== '设备分类') {
        this.treeSearchModel.equipmentType = newValue
      } else {
        delete this.treeSearchModel.equipmentType
      }
      if (this.searchModel.equipmentType) {
        delete this.searchModel.equipmentType
      }
      this.setSearchCondition(this.searchModel)
    }
  },
  methods: {
    // 展开图标
    expandIcon (props) {
      if (props.record.children && (props.record.children.length > 0 || props.record.children.length === 0 )) {
        if (props.expanded) {
          return (
            <span
              class="table-icon table-icon-down"
              onClick={(e) => {
                props.onExpand(props.record, e)
              }}
            >
              <a-icon type="caret-down" />
            </span>
          )
        } else {
          return (
            <span
              class="table-icon table-icon-right"
              onClick={(e) => {
                props.onExpand(props.record, e)
                this.tableCurrRowId = props.record.id
                this.getChildren(props.record)
              }}
            >
              <a-icon type="caret-right" />
            </span>
          )
        }
      } else {
        return <span style="margin-right:19px"></span>
      }
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      // 赋值同步本地data接受数据(我这里只取id即可)
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    // 改变scrollY
    changeScrollY (extraHeight, type) {
      this.$nextTick(() => {
        this.scrollY = getTableScroll(extraHeight, 'assetTable', type)
        const dom = document.getElementById('assetTable')
        if (type === 'addAssetTableHeigth') {
          dom.classList.add('assetTableHeight_126')
        } else {
          dom.classList.remove('assetTableHeight_126')
        }
      })
    },
    // 保存展开状态字段
    saveAdvanced (advanced) {
      this.advanced = advanced
    },
    // 打开抽屉
    openDrawer (type) {
      const obj = { edit: '编辑', copy: '复制' }
      if (['edit', 'copy'].includes(type)) {
        if (this.selectedRows.length === 0) {
          this.$message.error(`请选择需要${obj[type]}的数据！`)
          return
        } else if (this.selectedRows.length > 1) {
          this.$message.error(`只能选择一条数据进行${obj[type]}！`)
          return
        }
      }
      this.$refs.drawerDetail.setTitle(type === 'edit' ? '编辑设备' : '新增设备')
      this.$refs.drawerDetail.setType(type)
      if (['edit', 'copy'].includes(type)) {
        this.$refs.drawerDetail.setModel(this.selectedRows[0], type === 'copy' ? 'copy' : undefined)
      }
      this.$refs.drawerDetail.open(true)
    },
    // 导入
    handleImport () {
      this.$refs.importModal.open(true)
    },
    // 导出
    derive (searchModel) {
      const setSearchModel = { ...this.searchModel, ...this.treeSearchModel, ...searchModel, ...this.sort }
      this.$refs.drawerExport.setTitle('导出')
      this.$refs.drawerExport.setModel(setSearchModel)
      this.$refs.drawerExport.setType(this.$sysInfo.MODAL_ADD)
      this.$refs.drawerExport.open(true)
    },
    //  获取部门树用于第一次请求表格
    getDeptData () {
      const data = {
        paging: false,
        id: 0
      }
      getDeptTreeList(data).then(res => {
        if (res.status === 0) {
          this.treeSearchModel.subcompanyid = res.data[0].id
          this.setSearchCondition(this.searchModel)
        } else {
          this.$message.error(res.info.message)
        }
      })
    },
    // 修改表格数据
    formateData (data) {
      const childrenArr = []
      data.forEach(item => {
        item.showIndex = false
        if (item.children) {
          item.marginRight = true
          this.formateData(item.children)
        } else {
          item.marginLeft = true
        }
        childrenArr.push(item)
      })
      return childrenArr
    },
    // 获取表格数据
    getTableData (resetModel) {
      this.tableData.loading = true
      this.searchModel = { ...this.searchModel, ...this.pagination, ...this.sort, pid: 0  }
      // this.expandedRowKeys = ["214d0b67b68043009ab7a500c43d8f0f","123129830921831","123129830921832"]
      // this.tableCurrRowId = "123129830921831"
      this.selectedRows = []
      this.selectedRowKeys = []
      getEquipmentTableData(this.searchModel).then(res => {
        if (res.status === 0) {
          res.data.list.forEach((item) => {
            item.showIndex = true
            item.children = []
            if (item.children) {
              // 修改表格数据
              item.marginRight = true
              item.children = this.formateData(item.children)
            }
          })
          this.tableData.data = res.data.list
          console.log(this.tableData.data)
          this.pagination.total = res.data.total
          if (resetModel) {
            this.dataTabsModel = this.tableData.data[0]
          }
          this.tableData.loading = false
          if (this.advanced) {
            this.changeScrollY(90, 'addAssetTableHeigth')
          } else {
            this.changeScrollY(94)
          }
        } else {
          this.tableData.data = []
          this.tableData.total = 0
          this.tableData.loading = false
          this.$message.error(res.info.message)
        }
      })
      // 获取资产统计
      this.getAssetTotal()
    },
    // 获取假的子数据
    getChildren(data) {
      const params = {
        pid: data.id,
        paging: false
      }
      this.tableData.loading = true
      getEquipmentTableData(params).then(res => {
        // const index = this.tableData.data.findIndex(item => item.id === data.id)
        // this.tableData.data[index].children = res.data
        // this.tableData.loading = false
        if (res.data.length > 0) {
          for (const resData of res.data) {
            resData.children = []
          }
          data.children = res.data
        }
        // const index = this.tableData.data.findIndex(item => item.id === data.id)
        // this.tableData.data[index].children = res.data.list
        this.tableData.loading = false
      })
    },
    // 获取资产统计
    getAssetTotal () {
      getEquipmentTableTotal(this.searchModel).then(res => {
        if (res.status === 0) {
          if (res.data) {
            this.tableData.statistics = res.data
          } else {
            this.tableData.statistics = {
              normalSum: 0,
              abnormalSum: 0,
              normalaAmount: 0
            }
          }
        }
      })
    },
    // 搜索
    setSearchCondition (searchModel) {
      this.pagination.pageNum = 1
      this.pagination.current = 1
      this.searchModel = searchModel
      this.searchModel = { ...this.searchModel, ...this.treeSearchModel, ...searchModel }
      this.getTableData(true)
    },
    // 重置
    clearSearch (searchModel) {
      this.sort = {}
      this.sortedInfo = null
      this.pagination.pageNum = 1
      this.pagination.current = 1
      this.searchModel = searchModel
      this.searchModel = { ...this.searchModel, ...this.treeSearchModel }
      this.getTableData(true)
    },
    // 切换页码等操作
    handleTableChange (pagination, filters, sorter) {
      this.sortedInfo = sorter
      this.pagination.pageSize = pagination.pageSize
      this.pagination.pageNum = pagination.current
      this.pagination.current = pagination.current
      this.sort.sortName = sorter.field
      if (sorter.order) {
        if (sorter.order === 'ascend') {
          this.sort.sortType = 'asc'
        } else if (sorter.order === 'descend') {
          this.sort.sortType = 'desc'
        }
      } else {
        delete this.sort.sortName
        delete this.sort.sortType
        delete this.searchModel.sortName
        delete this.searchModel.sortType
      }
      this.searchModel = { ...this.searchModel, ...this.treeSearchModel }
      this.getTableData(true)
    },
    // 行
    changeRow (record) {
      return {
        on: {
          dblclick: (event) => { // 双击行,双击选中
            if (this.$auth('equipmentLedger.addOrEdit')) {
              if (!record.dblclickDisabled) {
                this.$refs.drawerDetail.setTitle('编辑设备')
                this.$refs.drawerDetail.setType('edit')
                this.$refs.drawerDetail.setModel(record)
                this.$refs.drawerDetail.open(true)
              }
            }
          },
          click: (event) => { // 单击行,双击选中
            this.tableCurrRowId = record.id
            this.dataTabsModel = {}
            this.dataTabsModel = record
          }
        }
      }
    },
    getDataTabs (id) {
      this.dataTabsModel = {}
      const data = {
        id: id
      }
      getEquipmentBasicInfo(data).then(res => {
        if (res.status === 0) {
          this.dataTabsModel = res.data
        }
      })
    },
    rowClassName (record, index) {
      return (record.id === this.tableCurrRowId) ? 'blue' : ''
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.ant-table-tbody .blue{
  background-color: #e6f7ff !important;
}
.rightTableDiv {
  height: 100%;
  /deep/.assetTable  {
    transition: height 300ms ease;
    height: calc(60% - 42px);
    >.ant-spin-nested-loading {
      height: 100%;
      >.ant-spin-container {
        height: calc(100% - 43px);
        .ant-table {
          height: 100%;
          .ant-table-content {
            height: 100%;
            .ant-table-scroll{
              height: 100%;
              .ant-table-body {
                transition: max-height 300ms ease;
                height: calc(100% - 80px);
              }
              >.ant-table-placeholder {
                position: absolute;
                background: none;
                border-top: none;
                border-bottom: none;
                border-radius: 0 0 4px 4px;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                margin: auto;
                height: 100px;
                .ant-empty-normal {
                  margin: 0 !important;
                }
              }
            }
          }
        }
        >.ant-table-pagination.ant-pagination {
          margin: 10px 0 0 0 !important;
        }
      }
    }
    .ant-table-pagination.ant-pagination {
      margin: 10px;
    }
  }
}
.listContent {
  .table {
    margin-top: 10px;
  }
}
.ant-table-row-collapsed::after {
  content: '+';
  color: #DDDDDD;
}
.ant-table-row-expanded::after {
  content: '-';
  color: #DDDDDD;
}
/deep/.ant-table-footer {
  padding: 0 !important;
  height: 40px;
  .footerDiv {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background-color: #E7F4FF;
    height: 100%;
    font-size: 14px;
    font-weight: 500;
    .footerDivOne ,.footerDivTwo ,.footerDivThree {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 0 20px;
      color: #333333;
      span:first-child {
        //margin-right: 20px;
      }
    }
    .footerDivOne {
      //border-right: 1px solid #DDDDDD;
    }
    .footerDivTwo {
      border-right: 1px solid #DDDDDD;
    }
  }
}
/deep/.ant-table-expanded-row{
  >td{
    padding: 0;
    .expand_row{
      display: flex;
      .expand_left{
        width: 80px;
        border-right: 1px solid #e8e8e8;
      }
      .expand_right{
        width: calc(100% - 80px);
        //padding: 0 10px 8px 10px;
      }
    }
  }
}
.assetTableHeight_126 {
  height: calc(60% - 126px) !important;
}
.assetNameTable {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}
/deep/.ant-table-row {
  td {
    padding: 6px 10px !important;
  }
  .ant-table-column-has-sorters:nth-child(3) {
    //display: flex;
    //height: 43px;
    //flex-direction: row;
    //justify-content: center;
    //align-items: center;
  }
}
.table-icon {
  margin-right: 7px;
  color: #87909f;
  font-size: 12px;
  cursor: pointer;
}
.table-icon-down {
  color: #08409f;
}
.table-icon-right {
  color: #dddddd;
}
.blueBtn {
  background: rgba(23, 145, 255, 0.1) !important;
  color: #1791FF;
  border: 1px solid rgba(23, 145, 255, 0.7) !important;
}
.orangeBtn {
  background: rgba(255, 142, 59, 0.1) !important;
  color: #FF8E3B;
  border: 1px solid rgba(255, 142, 59, 0.7) !important;
}
.greenBtn {
  background: rgba(54, 191, 125, 0.1) !important;
  color: #36BF7D;
  border: 1px solid rgba(54, 191, 125, 0.7) !important;
}
/deep/.ant-table-align-center {
  padding: 0 !important;
}
/deep/.ant-table-body-max-height-0 {
}
.padding-4-8 {
  padding: 4px 8px !important;
}
.xuIcon {
  margin-right: 5px;
  background: rgba(23,145,255,0.1);
  border: 1px solid rgba(23,145,255,0.7);
  font-size: 12px;
  padding: 2px 4px;
  border-radius: 3px;
  color: #1791FF;
}
.redIcon {
  margin-right: 5px;
  background-color: #E73B3B1A;
  border: 1px solid rgba(231, 59, 59, 0.7);
  font-size: 12px;
  padding: 3px 5px;
  border-radius: 3px;
  color: #E73B3B;
}
.orgIcon {
  margin-right: 5px;
  background: rgba(255,142,59,0.1);
  border: 1px solid rgba(255,142,59,0.7);
  font-size: 12px;
  padding: 3px 5px;
  border-radius: 3px;
  color: #FF8E3B;
}
.blueIcon {
  margin-right: 5px;
  background: rgba(23,145,255,0.1);
  border: 1px solid rgba(23,145,255,0.7);
  font-size: 12px;
  padding: 3px 5px;
  border-radius: 3px;
  color: #1791FF;
}
</style>
